
export const stat_for_team = {
    1:{
        shots:18+21+21+22,
        target:8+9+14+10,
        against:8+4+2+9,
        goals_pro:8+8+3,
        goals_against:1,
        red:1,
        yellow:5
    }
}